import { render } from "./InvestedProjectIcon.vue?vue&type=template&id=90f50bc8"
import script from "./InvestedProjectIcon.vue?vue&type=script&lang=js"
export * from "./InvestedProjectIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__